import React, { useContext } from "react";
import SearchHeader from "./SearchHeader";
import SearchResult from "./SearchResult";
import { SearchContext } from "../../context/SearchContextProvider";
import DefaultSpacing from "../page/DefaultSpacing";
import DownloadDocument from "./DownloadDocument";
import { Document } from "../page/DocumentList";
import { useMediaQuery, useTheme } from "@mui/system";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ExpandMore } from "@mui/icons-material";

interface Props {
    file: Document | undefined,
    setFile: (file: Document | undefined) => void
}

const SearchContent : React.FC<Props> = ({file, setFile}) => {
    const {searchTerms} = useContext(SearchContext);
    const fileId = file?.id;
    const {t} = useTranslation("common");
    const theme = useTheme();
    const greaterThanSmall = useMediaQuery(theme.breakpoints.up("md"));

    return <DefaultSpacing margin={{size: "small", applyTo: "all"}}>
        <SearchHeader file={file} onChange={(file: Document | undefined) => setFile(file)} />
        <DownloadDocument key={`download_doc_${fileId}`} fileId={fileId} />
        {fileId && searchTerms && searchTerms.length >= 0 && (greaterThanSmall ? 
            <SearchResult key={`result_fileid_${fileId}_${JSON.stringify(searchTerms)}`} fileId={fileId} /> 
            : <Accordion defaultExpanded elevation={0} sx={{"&:before": {height: '0px'}}}>
                <AccordionSummary
                    expandIcon={<ExpandMore />}>{t('common.search.result.title')}</AccordionSummary>
                <AccordionDetails>
                    <SearchResult key={`result_fileid_${fileId}_${JSON.stringify(searchTerms)}`} fileId={fileId} />
                </AccordionDetails>
            </Accordion>
        )}
    </DefaultSpacing>
}

export default SearchContent;